<talk-to-your-data-collapsible-section title="Quick Questions" [count]="(quickQuestions || []).length">
  <ng-container *ngIf="(quickQuestions || []).length > 0; else emptyState">
    <ul class="quick-question-list__items">
      <li class="quick-question-list__item" *ngFor="let question of quickQuestions || []; trackBy: trackByQuestionId">
        <button
          type="button"
          class="quick-question-list__button"
          [attr.title]="question.description"
          [attr.aria-label]="question.title"
          (click)="onQuestionSelected(question)"
        >
          {{ question.title }}
        </button>
      </li>
    </ul>
  </ng-container>

  <ng-template #emptyState>
    <p class="quick-question-list__empty">No quick questions available</p>
  </ng-template>
</talk-to-your-data-collapsible-section>
